<template>
    <youtube v-if="videoId" :video-id="videoId"></youtube>
</template>

<script>
export default {
    props: {
        url: String
    },

    computed: {
        videoId() {
            return this.$youtube.getIdFromUrl(this.url)
        }
    },

    watch: {
        videoId(to) {
            if (to) {
                this.$emit('input', to)
            }
        }
    }
}
</script>
